<main>
    <!-- HEADER -->
    <mat-card class="m-auto padding12 home-card boxshadowgrey">
        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/machineState">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <div class="side-header">
                <mat-card-title> {{"MASCHINESTATE.CALIBRATION.HEADER" | translate}}</mat-card-title> 
            </div>
        </mat-card-title-group>
        <!-- CONTENT -->
        <mat-card-content>
            <div class="home-card" id="content">
                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                    >{{"MESSAGES.CONN_WAITING" | translate}}</ng-container
                >

                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true">
                    <!-- CABINE -->
                    <div class="calibration-container">
                        <div class="calibration-header">
                            <a class="head">{{"MASCHINESTATE.CALIBRATION.CABINE.CABINE" | translate}}</a>
                            <ng-container *ngIf="this.cabineRunning">
                                <a class="running" [ngClass]="{'red': !this.cabineRunning, 'green': this.cabineRunning}">{{"MASCHINESTATE.CALIBRATION.RUNNING" | translate}}</a>
                            </ng-container>
                        </div>
                        <div class="calibration-content">
                            <button mat-raised-button color="primary" class="start-btn" [disabled]="this.cabineRunning || this.joystickRunning || this.pedalRunning || this.cabineLoading || this.joystickLoading || this.pedalLoading" (click)="startCalibrationCabine()">{{"MASCHINESTATE.CALIBRATION.START_BTN" | translate}}</button>
                            <div>
                                <ng-container *ngIf="this.cabineLoading">
                                    <div class="loading">
                                        <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="this.cabineEndpos == 'lower'">
                                    <div class="instruction">
                                        <mat-icon class="info-icon">info_outline</mat-icon>
                                        {{"MASCHINESTATE.CALIBRATION.CABINE.LOWER" | translate}}
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="this.cabineEndpos == 'upper'">
                                    <div class="instruction">
                                        <mat-icon class="info-icon">info_outline</mat-icon>
                                        {{"MASCHINESTATE.CALIBRATION.CABINE.UPPER" | translate}}
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="this.cabineSuccess">
                                    <div class="instruction">
                                        {{"MASCHINESTATE.CALIBRATION.SUCCESS" | translate}}
                                    </div>
                                </ng-container>
                            </div>
                            <div>
                                <ng-container *ngIf="this.cabineRunning && !this.cabineSuccess && this.cabineEndpos == 'lower' && !this.secondLow || this.cabineRunning && !this.cabineSuccess && this.cabineEndpos == 'upper'">
                                    <button mat-raised-button color="primary" class="confirm-btn" [class.clicked]="clicked" (click)="confirm()">
                                        <mat-progress-spinner
                                            *ngIf="clicked"
                                            diameter="20"
                                            mode="indeterminate"
                                            color="primary"
                                            class="spinner-centered"
                                        ></mat-progress-spinner>
                                        <span class="download-text" [class.invisible]="clicked">{{"MASCHINESTATE.CALIBRATION.CABINE.CONFIRM" | translate}}</span>
                                    </button>
                                </ng-container>
                            </div>
                            <div>
                                <ng-container *ngIf="this.cabineLoading || this.cabineRunning && !this.cabineSuccess">
                                    <button mat-stroked-button color="warn" class="start-btn" (click)="cancelCabine()">{{"MASCHINESTATE.CALIBRATION.CANCEL" | translate}}</button>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <!-- FINGERTIP-JOYSTICK -->
                    <div class="calibration-container">
                        <div class="calibration-header">
                            <a class="head">{{"MASCHINESTATE.CALIBRATION.FINGERTIP.FINGERTIP" | translate}}</a>
                            <ng-container *ngIf="this.joystickRunning">
                                <a class="running" [ngClass]="{'red': !this.joystickRunning, 'green': this.joystickRunning}">{{"MASCHINESTATE.CALIBRATION.RUNNING" | translate}}</a>
                            </ng-container>
                        </div>
                        <div class="calibration-content">
                            <div class="fingertip-joystick-content">
                                <a class="header bold">{{"MASCHINESTATE.CALIBRATION.FINGERTIP.VERTICAL" | translate}}</a>
                                <div class="fingertip-joystick-direction">
                                    <button mat-raised-button color="primary" class="start-btn" [disabled]="this.joystickRunning || this.cabineRunning || this.pedalRunning || this.joystickLoading || this.cabineLoading || this.pedalLoading" (click)="startCalibrationJoystick('up')">{{"MASCHINESTATE.CALIBRATION.START_BTN" | translate}}</button>
                                    <div>
                                        <ng-container *ngIf="this.joystickLoading && this.joystickDirection == 'up'">
                                            <div class="loading">
                                                <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="this.joystickUp">
                                            <div class="instruction">
                                                <mat-icon class="info-icon">info_outline</mat-icon>
                                                {{"MASCHINESTATE.CALIBRATION.FINGERTIP.UP" | translate}}
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="this.joystickSuccess && this.joystickDirection == 'up'">
                                            <div class="instruction">
                                                {{"MASCHINESTATE.CALIBRATION.SUCCESS" | translate}}
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div>
                                        <ng-container *ngIf="this.joystickLoading && this.joystickDirection == 'up' || this.joystickRunning && !this.joystickSuccess && this.joystickDirection == 'up'">
                                            <button mat-stroked-button color="warn" class="start-btn" (click)="cancelJoystick('up')">{{"MASCHINESTATE.CALIBRATION.CANCEL" | translate}}</button>
                                        </ng-container>
                                    </div>
                                </div>
                                <!--<div class="divider"></div>-->
                                <a class="header bold">{{"MASCHINESTATE.CALIBRATION.FINGERTIP.HORIZONTAL" | translate}}</a>
                                <div class="fingertip-joystick-direction">
                                    <button mat-raised-button color="primary" class="start-btn" [disabled]="this.joystickRunning || this.cabineRunning || this.pedalRunning || this.joystickLoading || this.cabineLoading || this.pedalLoading" (click)="startCalibrationJoystick('left')">{{"MASCHINESTATE.CALIBRATION.START_BTN" | translate}}</button>
                                    <div>
                                        <ng-container *ngIf="this.joystickLoading && this.joystickDirection == 'left'">
                                            <div class="loading">
                                                <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="this.joystickLeft">
                                            <div class="instruction">
                                                <mat-icon class="info-icon">info_outline</mat-icon>
                                                {{"MASCHINESTATE.CALIBRATION.FINGERTIP.LEFT" | translate}}
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="this.joystickSuccess && this.joystickDirection == 'left'">
                                            <div class="instruction">
                                                {{"MASCHINESTATE.CALIBRATION.SUCCESS" | translate}}
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div>
                                        <ng-container *ngIf="this.joystickLoading && this.joystickDirection == 'left' || this.joystickDirection == 'left' && this.joystickRunning && !this.joystickSuccess">
                                            <button mat-stroked-button color="warn" class="start-btn" (click)="cancelJoystick('left')">{{"MASCHINESTATE.CALIBRATION.CANCEL" | translate}}</button>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- PEDAL -->
                    <div class="calibration-container">
                        <div class="calibration-header">
                            <a class="head">{{"MASCHINESTATE.CALIBRATION.PEDAL.PEDAL" | translate}}</a>
                            <ng-container *ngIf="this.pedalRunning">
                                <a class="running" [ngClass]="{'red': !this.pedalRunning, 'green': this.pedalRunning}">{{"MASCHINESTATE.CALIBRATION.RUNNING" | translate}}</a>
                            </ng-container>
                        </div>
                        <div class="calibration-content">
                            <button mat-raised-button color="primary" class="start-btn" [disabled]="this.pedalRunning || this.joystickRunning || this.cabineRunning || this.pedalLoading || this.joystickLoading || this.cabineLoading" (click)="startCalibrationPedal()">{{"MASCHINESTATE.CALIBRATION.START_BTN" | translate}}</button>
                            <div>
                                <ng-container *ngIf="this.pedalLoading">
                                    <div class="loading">
                                        <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="this.pedalInfo">
                                    <div class="instruction">
                                        <mat-icon class="info-icon">info_outline</mat-icon>
                                        {{"MASCHINESTATE.CALIBRATION.PEDAL.DOWN" | translate}}
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="this.pedalSuccess">
                                    <div class="instruction">
                                        {{"MASCHINESTATE.CALIBRATION.SUCCESS" | translate}}
                                    </div>
                                </ng-container>
                            </div>
                            <div>
                                <ng-container *ngIf="this.pedalLoading || this.pedalRunning && !this.pedalSuccess">
                                    <button mat-stroked-button color="warn" class="start-btn" (click)="cancelPedal()">{{"MASCHINESTATE.CALIBRATION.CANCEL" | translate}}</button>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    
                </ng-container>
            </div>
        </mat-card-content>
    </div>
    </mat-card>
</main>
